import * as React from 'react'

import { Box, SearchField, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import type { Employees } from 'modules/employees/store/collections/employees'
import type SurveyForm from 'modules/surveys/store/models/Form'
import type QuestionGroup from 'modules/surveys/store/models/QuestionGroup'
import type Survey from 'modules/surveys/store/models/v2/Survey'

import Body from './Body'
import Header from './Header'

interface Props {
  form: SurveyForm | Survey
  questionGroups: QuestionGroup[]
  employees: Employees
}

function ResponsesTable({ form, questionGroups, employees }: Props) {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()

  const TableOptions = () => (
    <Box flexGrow>
      <SearchField
        variant="big"
        search={search}
        onSearch={onSearch}
        placeholder={i18n.t('common.search')}
      />
    </Box>
  )

  return (
    <Table options={TableOptions}>
      <Header />
      <Body
        form={form}
        search={debouncedSearch}
        questionGroups={questionGroups}
        employees={employees}
      />
    </Table>
  )
}

export default observer(ResponsesTable)
